<template>
  <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
    <el-card shadow="always" class="c-1">
      <div class="row">
        <div class="col-8">
          <div class="numbers">
            <p class="text-sm mb-0 text-uppercase font-weight-bold">{{ title }}</p>
            <h5 class="font-weight-bolder">
              {{ value }}
            </h5>
          </div>
        </div>
        <div class="col-4 text-end">
          <div :class="'icon icon-shape shadow-primary text-center rounded-circle ' + color">
            <i :class="'ni text-lg opacity-10 ' + icon" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name: "PrepostHomeDashColumn",
  props: ['title', 'value', 'icon', 'color']
}
</script>

<style scoped>
.ni {
  color: #fff;
}
.txt-12 {
  font-size: 12px;
}
.c-1 {

}
</style>
